import { courseActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  Name: '',
  Type: '',
  Description: '',
  Duration: '',
  SlugURL: '',
  OrderNumber: '',
  ThumbnailURL: ''
};

const defaultState = {
  courseList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case courseActions.COURSES_FETCH_START:
      return updateState(state, { tableLoading: true });
    case courseActions.COURSES_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, courseList: actions.payload });
    case courseActions.COURSES_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case courseActions.COURSES_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case courseActions.COURSES_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case courseActions.COURSES_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case courseActions.COURSES_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case courseActions.COURSES_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
